document.addEventListener('DOMContentLoaded', () => {
	// Detect language from URL path and set phone field initial country.
	const pathParts = window.location.pathname.split('/').filter(Boolean);
	const possibleLanguage = pathParts[0];

	// Map URL language codes to country codes for International Telephone Input.
	const languageToCountry = {
		de: 'de', // Germany
		fr: 'fr', // France
		en: 'au', // Australia
		it: 'it', // Italy
		es: 'es', // Spain
		us: 'au', // Australia
	};

	// Default to Germany if no language is detected.
	const countryCode = languageToCountry[possibleLanguage] || 'de';

	// Wait for ITI elements to be rendered, then set country
	const phoneInput = document.querySelector('.evf-smart-phone-field');
	if (!phoneInput) {
		return;
	}

	// Use MutationObserver to detect when ITI elements appear
	const observer = new MutationObserver(() => {
		const countryList = document.querySelector('.iti__country-list');
		const selectedFlag = document.querySelector('.iti__selected-flag');

		if (!countryList || !selectedFlag) {
			return; // Not ready yet
		}

		// Stop observing once we find them
		observer.disconnect();

		// Remove active state from all countries
		document.querySelectorAll('.iti__country').forEach(item => {
			item.classList.remove('iti__active');
			item.removeAttribute('aria-selected');
		});

		// Find target country
		const targetCountry = countryList.querySelector(`[data-country-code="${countryCode}"]`);
		if (!targetCountry) {
			return;
		}

		// Activate the target country
		targetCountry.classList.add('iti__active');
		targetCountry.setAttribute('aria-selected', 'true');

		// Update flag display
		const flagEl = selectedFlag.querySelector('.iti__flag');
		if (flagEl) {
			flagEl.className = `iti__flag iti__${countryCode}`;
		}

		// Update title
		const countryName = targetCountry.querySelector('.iti__country-name')?.textContent || '';
		const dialCode = targetCountry.querySelector('.iti__dial-code')?.textContent || '';
		selectedFlag.title = `${countryName}: ${dialCode}`;
		selectedFlag.setAttribute('aria-activedescendant', targetCountry.id);

		// Dispatch change event
		phoneInput.dispatchEvent(new Event('change', { bubbles: true }));
	});

	// Watch for changes in the entire document body
	observer.observe(document.body, {
		childList: true,
		subtree: true,
		attributes: true,
		attributeFilter: ['class'],
	});

	// Also try immediately in case elements are already there
	setTimeout(() => {
		const countryList = document.querySelector('.iti__country-list');
		const selectedFlag = document.querySelector('.iti__selected-flag');
		if (countryList && selectedFlag) {
			observer.disconnect();
			observer.takeRecords(); // Clear any pending observations
		}
	}, 500);

	const success = document.querySelector('.everest-forms-notice');

	if (!success) {
		console.log('[Contact Form] No success notice found');
		return;
	}

	console.log('[Contact Form] Success notice found:', success);

	// Check if this is a VC Tabs form (has .vc_tta-panel-body parent)
	const tabPanel = success.closest('.vc_tta-panel-body');
	if (tabPanel) {
		console.log('[Contact Form] VC Tabs form detected');
		// VC Tabs form behavior - simulate tab click
		const vctaPanel = tabPanel.closest('.vc_tta-panel');
		console.log('[Contact Form] vctaPanel:', vctaPanel);
		if (vctaPanel) {
			const panelId = vctaPanel.id;
			console.log('[Contact Form] panelId:', panelId);
			// Find the container and then the tab link
			const vctaContainer = vctaPanel.closest('.vc_tta-container');
			console.log('[Contact Form] vctaContainer:', vctaContainer);
			if (vctaContainer) {
				const tabLink = vctaContainer.querySelector(
					`a[href="#${panelId}"]`
				);
				console.log('[Contact Form] tabLink:', tabLink);
				if (tabLink) {
					console.log('[Contact Form] Clicking tab link');
					tabLink.click();
				} else {
					console.log('[Contact Form] No tab link found for panel');
				}
			}
		} else {
			console.log('[Contact Form] No .vc_tta-panel parent found');
		}
	} else {
		// Regular form behavior (original)
		console.log('[Contact Form] Regular form detected');
		const parent = success.closest('#prod-request');
		if (!parent) {
			console.log('[Contact Form] No #prod-request parent found');
			return;
		}
		parent.style.setProperty('display', 'block', 'important');
		console.log('[Contact Form] #prod-request parent displayed');
	}

	// Wait for animation to complete, then smooth scroll into view
	const scrollToSuccess = () => {
		// Add delay to ensure other scripts finish scrolling first
		setTimeout(() => {
			const topPos = success.getBoundingClientRect().top + window.scrollY - 100;

			window.scrollTo({
				top: topPos,
				behavior: 'smooth',
			});
		}, 500);
	};

	// Listen for animation end
	success.addEventListener('animationend', scrollToSuccess, { once: true });
	// Wait for page to fully load and settle
	window.addEventListener('load', scrollToSuccess, { once: true });
});
